<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <CommonTitle class="sp-h1-font-size  fs-24-bold" :titleProps="'送信完了'"/>
        <b-card class="mt-3 min-vh-75">
            <p class="mb-0 mt-1 fs-14-regular">
              ご連絡ありがとうございました。ご記入内容にて受付をいたしました。<br>
              折り返し弊社より、お問い合わせ受付通知を、報告先メールアドレスにお送りいたします。<br>
            <br>
              1時間以上経過しても弊社からのメールが受信できない場合は、恐れ入りますが下記までご連絡ください。<br>
            <br>
              <a class="text-primary fs-12-regular" href="mailto:bell24-tas@e-hisyo.com"><u>E-mail：bell24-tas@e-hisyo.com</u></a>
            </p>
        </b-card>
      </main>
    </b-container>
  </div>
</template>
<script>

// NOTE: 共通タイトルUI
import CommonTitle from '../../../components/common/CommonTitle'

export default {
  components: {
    CommonTitle
  },
  computed: {
    isSpUserAgent () {
      return navigator.userAgent.match(/iPhone|Android.+Mobile/)
    }
  }
}
</script>
<style lang="scss">
@media screen and (max-width: 480px) {
    .sp-h1-font-size {
      font-size: 1.5rem !important;
    }
    .sp-button-size {
      width: 200px !important;
    }
    .sp-button-center {
      text-align: center !important;
    }
}

.min-vh-75{
  min-height: 75vh;
}
</style>
